var _defs, _text, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRentelonWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 374.7 224.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:95.91px;font-family:Nunito-Bold, Nunito;font-weight:700;}.cls-1,.cls-5{fill:#fff;}.cls-2{letter-spacing:-0.01em;}.cls-3{letter-spacing:0em;}.cls-4{letter-spacing:0em;}"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(0 198.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 36.83,
    y: 0
  }, "en"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 144.91,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 181.26,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 233.24,
    y: 0
  }, "l"), /*#__PURE__*/React.createElement("tspan", {
    x: 263.36,
    y: 0
  }, "on"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M265,124c-.95,2.62-1.55,5.44-2.91,7.82Q248.83,155,235.26,178.07a14.65,14.65,0,0,1-26.08-13.25,76.13,76.13,0,0,1,4.57-8.41c7.45-12.87,15-25.71,22.39-38.6,2.59-4.49,6-7.7,11.36-8.49C256.65,108,264.41,114.57,265,124Z",
    transform: "translate(-58.44 -109.14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M273.67,150c11.54.13,18.6,11.51,13,21.6-7.72,14-15.73,27.82-23.89,41.55-5,8.44-14.86,10.25-22.21,4.53a14.26,14.26,0,0,1-3.53-18.57c6.51-11.57,13.2-23,19.84-34.54,1.59-2.77,3.13-5.58,4.91-8.23A14.1,14.1,0,0,1,273.67,150Z",
    transform: "translate(-58.44 -109.14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M216.62,206.36A14.64,14.64,0,0,1,201.37,221c-7.64-.11-13.84-6.87-14-14.76a14.61,14.61,0,1,1,29.21.13Z",
    transform: "translate(-58.44 -109.14)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M312,206.35c.29,8.76-7,14.7-15.13,14.63-7.52-.06-14.14-7.06-14.06-14.74a14.6,14.6,0,0,1,14.92-14.6A14.3,14.3,0,0,1,312,206.35Z",
    transform: "translate(-58.44 -109.14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentelonWhiteLogo);
export default __webpack_public_path__ + "static/media/rentelon-white-logo.f1d4e19c600c7e80d7f798b57516d6ab.svg";
export { ForwardRef as ReactComponent };